module.exports = __webpack_public_path__ + "assets/img/banner-6.77e642db.png";